import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Modal } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
import { getSellerDetail, verifySeller, resendVerificationEmail, updateSellerProfile } from "../../../actions/vendorActions";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import BlockIcon from "@material-ui/icons/Block";
import EmailIcon from "@material-ui/icons/Email";
import EditIcon from "@material-ui/icons/Edit";
import StoreIcon from "@material-ui/icons/Store";
import CategoryIcon from "@material-ui/icons/Category";
import BusinessIcon from "@material-ui/icons/Business";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhoneIcon from "@material-ui/icons/Phone";
import PersonIcon from "@material-ui/icons/Person";
import BadgeIcon from "@material-ui/icons/AccountBox";
import ReceiptIcon from "@material-ui/icons/Receipt";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import SaveIcon from "@material-ui/icons/Save";
import DescriptionIcon from "@material-ui/icons/Description";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { getUserFromLocalStorage } from "utilities/user";
import { toast } from "react-toastify";
import { useGoogleMaps } from "../../../GoogleMapsContext";
import LocationAutocomplete from "../../LocationAutoComplete";
import usePlacesAutocomplete from "use-places-autocomplete";
import AppSelect from "../../../components/ui/AppSelect";

// Styles for horizontal layout
const styles = {
  pageWrapper: {
    minHeight: "100vh",
    backgroundColor: "#f5f7fa",
    padding: "20px",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#023957ff",
    padding: "16px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px",
  },
  headerTitle: {
    color: "#ffffff",
    fontSize: "18px",
    fontWeight: "600",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  editModeButton: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: "#ffffff",
    border: "none",
    padding: "8px 16px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    transition: "background-color 0.2s",
  },
  verificationBadge: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "5px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
  },
  verifiedBadge: {
    backgroundColor: "rgba(160, 251, 2, 0.94)",
    color: "#215f00ff",
  },
  pendingBadge: {
    backgroundColor: "rgba(239, 68, 68, 0.2)",
    color: "#ffffff",
  },
  mainContent: {
    display: "flex",
    flexDirection: "row",
    gap: "0",
    minHeight: "400px",
  },
  leftPanel: {
    width: "260px",
    borderRight: "1px solid #f0f0f0",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    backgroundColor: "#fafafa",
  },
  rightPanel: {
    flex: 1,
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  imageContainer: {
    position: "relative",
    width: "100%",
    height: "140px",
    overflow: "hidden",
    cursor: "pointer",
    backgroundColor: "#e8e8e8",
    borderRadius: "12px",
    border: "2px solid #e0e0e0",
  },
  licenseImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.3s ease",
  },
  imageOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 0.3s ease",
    color: "#ffffff",
    fontSize: "12px",
    gap: "6px",
  },
  actionButtonsVertical: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginTop: "auto",
  },
  detailsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "8px 20px",
  },
  detailItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    padding: "8px 0",
  },
  detailIcon: {
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    backgroundColor: "#e8f5e9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  detailIconSvg: {
    fontSize: "14px",
    color: "#065702",
  },
  detailContent: {
    flex: 1,
    minWidth: 0,
  },
  detailLabel: {
    fontSize: "10px",
    color: "#888",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "2px",
  },
  detailValue: {
    fontSize: "13px",
    color: "#1a1a1a",
    fontWeight: "500",
    wordBreak: "break-word",
  },
  editInput: {
    width: "100%",
    padding: "6px 10px",
    fontSize: "13px",
    border: "2px solid #065702",
    borderRadius: "6px",
    outline: "none",
  },
  editSelect: {
    width: "100%",
    padding: "6px 10px",
    fontSize: "13px",
    border: "2px solid #065702",
    borderRadius: "6px",
    outline: "none",
    backgroundColor: "#fff",
  },
  editButton: {
    backgroundColor: "transparent",
    border: "none",
    padding: "4px",
    cursor: "pointer",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s",
  },
  primaryButton: {
    backgroundColor: "#065702",
    color: "#ffffff",
    border: "none",
    padding: "10px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "background-color 0.2s",
    width: "100%",
  },
  dangerButton: {
    backgroundColor: "#dc3545",
    color: "#ffffff",
    border: "none",
    padding: "10px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "background-color 0.2s",
    width: "100%",
  },
  secondaryButton: {
    backgroundColor: "#ffffff",
    color: "#065702",
    border: "2px solid #065702",
    padding: "8px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "all 0.2s",
    width: "100%",
  },
  saveButton: {
    backgroundColor: "#065702",
    color: "#ffffff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
  },
  cancelButton: {
    backgroundColor: "#6c757d",
    color: "#ffffff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "300px",
  },
  licenseLabel: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  fullWidth: {
    gridColumn: "1 / -1",
  },
  sectionTitle: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#065702",
    marginBottom: "8px",
    marginTop: "12px",
    paddingBottom: "6px",
    borderBottom: "1px solid #e0e0e0",
    gridColumn: "1 / -1",
  },
  editActionsBar: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    padding: "16px 20px",
    borderTop: "1px solid #f0f0f0",
    backgroundColor: "#fafafa",
  },
};

const operationModeOptions = [
  { value: "RESTAURANT", label: "Restaurant" },
  { value: "RETAILER", label: "Retailer" },
  { value: "WHOLESALER", label: "Wholesaler" },
  { value: "HEALTHCARE", label: "Healthcare" },
];

// Editable Detail Item Component - defined outside to prevent re-creation on each render
const EditableDetailItem = ({ 
  icon: Icon, 
  label, 
  field, 
  value, 
  fullWidth, 
  type = "text", 
  options = null,
  isEditMode,
  isSuperUser,
  editData,
  onInputChange
}) => (
  <div style={{ ...styles.detailItem, ...(fullWidth ? styles.fullWidth : {}) }}>
    <div style={styles.detailIcon}>
      <Icon style={styles.detailIconSvg} />
    </div>
    <div style={styles.detailContent}>
      <div style={styles.detailLabel}>{label}</div>
      {isEditMode && isSuperUser ? (
        options ? (
          <AppSelect
            style={styles.editSelect}
            value={editData[field] || ""}
            onChange={(e) => onInputChange(field, e.target.value)}
          >
            {options.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </AppSelect>
        ) : (
          <input
            type={type}
            style={styles.editInput}
            value={editData[field] || ""}
            onChange={(e) => onInputChange(field, e.target.value)}
            placeholder={`Enter ${label.toLowerCase()}`}
          />
        )
      ) : (
        <div style={styles.detailValue}>{value || "N/A"}</div>
      )}
    </div>
  </div>
);

// Read-only Detail Item - defined outside to prevent re-creation on each render
const DetailItem = ({ icon: Icon, label, value, fullWidth }) => (
  <div style={{ ...styles.detailItem, ...(fullWidth ? styles.fullWidth : {}) }}>
    <div style={styles.detailIcon}>
      <Icon style={styles.detailIconSvg} />
    </div>
    <div style={styles.detailContent}>
      <div style={styles.detailLabel}>{label}</div>
      <div style={styles.detailValue}>{value || "N/A"}</div>
    </div>
  </div>
);

// Custom hook for Google Places Autocomplete
function useCustomPlacesAutocomplete(mapsApiLoaded) {
  const options = {
    requestOptions: {
      componentRestrictions: { country: "ug" },
      cacheTimeout: 10 * 60 * 60 * 24,
      debounce: 100,
      location: { lat: () => 0.347596, lng: () => 32.58252 },
      radius: 200 * 1000,
      origin: { lat: 0.3148136, lng: 32.5788721 },
      strictBounds: true,
      types: ["establishment"],
    },
    debounce: 100,
  };

  const {
    value,
    ready,
    suggestions: { data, loading: placesLoading, status: suggestionStatus } = { data: [] },
    setValue,
    clearSuggestions,
    status,
  } = usePlacesAutocomplete(options);

  useEffect(() => {
    if (mapsApiLoaded) {
      setValue("");
    }
  }, [mapsApiLoaded, setValue]);

  useEffect(() => {
    if (status === "ERROR") {
      console.error("Error fetching suggestions:", status);
    }
  }, [status]);

  return {
    value,
    ready,
    data,
    placesLoading,
    suggestionStatus,
    setValue,
    clearSuggestions,
  };
}

const SellerDetailsCard = ({ match }) => {
  const user = getUserFromLocalStorage();
  const dispatch = useDispatch();
  const { mapsApiLoaded } = useGoogleMaps();
  
  const [showModal, setShowModal] = useState(false);
  const [imageHovered, setImageHovered] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [isResendingEmail, setIsResendingEmail] = useState(false);

  // Activation modal — only shown when an admin is about to verify a
  // SEEDED vendor (one whose email is still the `seed-<phone>@lusuku.pending`
  // placeholder from sellerFactory). We use this single moment to capture
  // the real email + confirm the phone so the backend can auto-send the
  // vendor a password-reset link and they can log in. Non-seeded vendors
  // skip this entirely — their Verify button flow is untouched.
  const [showActivationModal, setShowActivationModal] = useState(false);
  const [activationEmail, setActivationEmail] = useState("");
  const [activationPhone, setActivationPhone] = useState("");
  
  // Google Places Autocomplete
  const { value: locationValue, ready, data: locationData, placesLoading, suggestionStatus, setValue: setLocationValue, clearSuggestions } =
    useCustomPlacesAutocomplete(mapsApiLoaded);
  
  // Editable fields state
  const [editData, setEditData] = useState({
    businessName: "",
    email: "",
    businessPhone: "",
    businessAddress: "",
    typeOfGoods: "",
    operationMode: "",
    businessTIN: "",
    // Healthcare specific
    medicalLicenseNumber: "",
    certifications: "",
    specializations: "",
  });

  const sellerID = match.params.id;
  const { seller, loading } = useSelector((state) => state.sellers);
  const isSuperUser = user?.result?.user_role === "SUPERUSER";

  // Seeded vendors are created by sellerFactory with a placeholder email of
  // the form `seed-<digits>@lusuku.pending`. When we see that exact shape we
  // know the vendor hasn't supplied a real email yet, so verifying them is
  // also the moment to capture their real contact info and trigger the
  // password-reset magic link. Any other email shape means a normal
  // self-serve vendor — verify stays a one-click action for those.
  const isSeedPlaceholder = /^seed-\d+@lusuku\.pending$/i.test(
    seller?.email || ""
  );

  useEffect(() => {
    dispatch(getSellerDetail(sellerID));
  }, [dispatch, sellerID]);

  // Populate edit data when seller loads
  useEffect(() => {
    if (seller) {
      setEditData({
        businessName: seller.businessName || "",
        email: seller.email || "",
        businessPhone: seller.businessPhone || "",
        businessAddress: seller.businessAddress || "",
        typeOfGoods: seller.typeOfGoods || "",
        operationMode: seller.operationMode || "",
        businessTIN: seller.businessTIN || "",
        medicalLicenseNumber: seller.medicalLicenseNumber || "",
        certifications: seller.certifications || "",
        specializations: seller.specializations || "",
      });
    }
  }, [seller]);

  const handleMouseEnter = () => {
    setImageHovered(true);
  };

  const handleMouseLeave = () => {
    setImageHovered(false);
  };

  const handleImageClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleInputChange = (field, value) => {
    setEditData(prev => ({ ...prev, [field]: value }));
  };

  // Handle location selection from Google Places Autocomplete
  const handleLocationSelect = ({ address, latitude, longitude }) => {
    setEditData(prev => ({ ...prev, businessAddress: address }));
  };

  const handleEditToggle = () => {
    if (isEditMode) {
      // Cancel - reset to original values
      setEditData({
        businessName: seller?.businessName || "",
        email: seller?.email || "",
        businessPhone: seller?.businessPhone || "",
        businessAddress: seller?.businessAddress || "",
        typeOfGoods: seller?.typeOfGoods || "",
        operationMode: seller?.operationMode || "",
        businessTIN: seller?.businessTIN || "",
        medicalLicenseNumber: seller?.medicalLicenseNumber || "",
        certifications: seller?.certifications || "",
        specializations: seller?.specializations || "",
      });
    }
    setIsEditMode(!isEditMode);
  };

  const handleSaveChanges = async () => {
    setIsSaving(true);
    try {
      await dispatch(updateSellerProfile(sellerID, editData));
      setIsEditMode(false);
    } catch (error) {
      console.error("Failed to update profile:", error);
      // Error message is already shown by the action via toast
    }
    setIsSaving(false);
  };

  const handleResendEmail = async () => {
    setIsResendingEmail(true);
    try {
      await dispatch(resendVerificationEmail(sellerID));
    } catch (error) {
      console.error("Failed to resend email:", error);
    }
    setIsResendingEmail(false);
  };

  // Single entry point for the "Verify Vendor" button. For self-serve
  // vendors this is unchanged — a one-click dispatch. For seeded vendors
  // we open a small modal first so the admin can capture the real email
  // and confirm the phone the factory saved as `businessPhone`.
  const handleVerifyClick = () => {
    if (isSeedPlaceholder) {
      setActivationEmail("");
      setActivationPhone(seller?.businessPhone || "");
      setShowActivationModal(true);
      return;
    }
    dispatch(
      verifySeller(sellerID, user?.result?._id, "VERIFIED", new Date())
    );
  };

  // Close the activation modal and reset its transient state.
  const handleCloseActivationModal = () => {
    setShowActivationModal(false);
    setActivationEmail("");
    setActivationPhone("");
  };

  // Submit the activation modal. We pass the captured fields through the
  // existing `verifySeller` action — the backend only upgrades the email
  // when the current one is still the seed placeholder, so replaying this
  // later for an already-activated vendor is a no-op on the email side.
  // `clientUrl` is the dashboard base for the PasswordReset magic link
  // (route `/reset-password/:token/:id`).
  const handleSubmitActivation = () => {
    const email = activationEmail.trim();
    const phoneNumber = activationPhone.trim();
    if (!email && !phoneNumber) {
      toast.error(
        "Please provide at least an email or a phone number to activate the vendor."
      );
      return;
    }
    dispatch(
      verifySeller(
        sellerID,
        user?.result?._id,
        "VERIFIED",
        new Date(),
        {
          email,
          phoneNumber,
          clientUrl: `${window.location.origin}/reset-password`,
        }
      )
    );
    handleCloseActivationModal();
  };

  const formatText = (text) => {
    if (!text) return "N/A";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  return (
    <div style={styles.pageWrapper}>
      {loading ? (
        <div style={styles.loadingContainer}>
          <CircularProgress style={{ color: "#023957" }} />
        </div>
      ) : (
        <Container fluid style={{ maxWidth: "1100px", padding: 0 }}>
          <div style={styles.card}>
            {/* Header */}
            <div style={styles.header}>
              <h2 style={styles.headerTitle}>
                <StoreIcon style={{ fontSize: "22px" }} />
                {seller?.businessName || "Vendor Details"}
              </h2>
              <div style={styles.headerActions}>
                {isSuperUser && (
                  <button
                    style={styles.editModeButton}
                    onClick={handleEditToggle}
                  >
                    {isEditMode ? (
                      <>
                        <CancelIcon style={{ fontSize: "16px" }} />
                        Cancel
                      </>
                    ) : (
                      <>
                        <EditIcon style={{ fontSize: "16px" }} />
                        Edit Profile
                      </>
                    )}
                  </button>
                )}
                <div
                  style={{
                    ...styles.verificationBadge,
                    ...(seller?.sellerVerification === "PENDING"
                      ? styles.pendingBadge
                      : styles.verifiedBadge),
                  }}
                >
                  {seller?.sellerVerification === "PENDING" ? (
                    <>
                      <BlockIcon style={{ fontSize: "14px" }} />
                      Pending
                    </>
                  ) : (
                    <>
                      <VerifiedUserIcon style={{ fontSize: "14px" }} />
                      Verified
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Main Content - Horizontal Layout */}
            <div style={styles.mainContent}>
              {/* Left Panel - License Image & Actions */}
              <div style={styles.leftPanel}>
                {/* License Image */}
                <div>
                  <div style={styles.licenseLabel}>
                    <DescriptionIcon style={{ fontSize: "14px", color: "#065702" }} />
                    Trading License
                  </div>
                  {seller?.businessTradingLicense ? (
                    <div
                      style={styles.imageContainer}
                      onClick={handleImageClick}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <img
                        src={seller.businessTradingLicense}
                        alt="Business Trading License"
                        style={{
                          ...styles.licenseImage,
                          transform: imageHovered ? "scale(1.05)" : "scale(1)",
                        }}
                      />
                      <div style={{ ...styles.imageOverlay, opacity: imageHovered ? 1 : 0 }}>
                        <ZoomInIcon style={{ fontSize: "24px" }} />
                        Click to enlarge
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        ...styles.imageContainer,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#999",
                        fontSize: "12px",
                      }}
                    >
                      No license uploaded
                    </div>
                  )}
                </div>

                {/* Action Buttons */}
                <div style={styles.actionButtonsVertical}>
                  {seller?.sellerVerification === "PENDING" ? (
                    <button
                      style={{
                        ...styles.primaryButton,
                        opacity: !isSuperUser ? 0.6 : 1,
                        cursor: !isSuperUser ? "not-allowed" : "pointer",
                      }}
                      disabled={!isSuperUser}
                      onClick={handleVerifyClick}
                    >
                      <VerifiedUserIcon style={{ fontSize: "16px" }} />
                      {isSeedPlaceholder ? "Verify & Activate" : "Verify Vendor"}
                    </button>
                  ) : (
                    <>
                      <button
                        style={styles.dangerButton}
                        onClick={() =>
                          dispatch(
                            verifySeller(
                              sellerID,
                              user?.result?._id,
                              "PENDING",
                              new Date()
                            )
                          )
                        }
                      >
                        <BlockIcon style={{ fontSize: "16px" }} />
                        Deactivate
                      </button>
                      <button
                        style={{
                          ...styles.secondaryButton,
                          opacity: isResendingEmail ? 0.7 : 1,
                          cursor: isResendingEmail ? "not-allowed" : "pointer",
                        }}
                        onClick={handleResendEmail}
                        disabled={isResendingEmail}
                      >
                        {isResendingEmail ? (
                          <CircularProgress size={16} style={{ color: "#023957" }} />
                        ) : (
                          <EmailIcon style={{ fontSize: "16px" }} />
                        )}
                        {isResendingEmail ? "Sending..." : "Resend Email"}
                      </button>
                    </>
                  )}
                </div>
              </div>

              {/* Right Panel - Details Grid */}
              <div style={styles.rightPanel}>
                <div style={styles.detailsGrid}>
                  {/* Business Information Section */}
                  <div style={styles.sectionTitle}>Business Information</div>
                  
                  <EditableDetailItem
                    icon={StoreIcon}
                    label="Business Name"
                    field="businessName"
                    value={seller?.businessName}
                    isEditMode={isEditMode}
                    isSuperUser={isSuperUser}
                    editData={editData}
                    onInputChange={handleInputChange}
                  />
                  <EditableDetailItem
                    icon={BusinessIcon}
                    label="Operation Mode"
                    field="operationMode"
                    value={formatText(seller?.operationMode)}
                    options={operationModeOptions}
                    isEditMode={isEditMode}
                    isSuperUser={isSuperUser}
                    editData={editData}
                    onInputChange={handleInputChange}
                  />
                  <EditableDetailItem
                    icon={CategoryIcon}
                    label="Type of Goods"
                    field="typeOfGoods"
                    value={seller?.typeOfGoods}
                    isEditMode={isEditMode}
                    isSuperUser={isSuperUser}
                    editData={editData}
                    onInputChange={handleInputChange}
                  />
                  <EditableDetailItem
                    icon={PhoneIcon}
                    label="Business Phone"
                    field="businessPhone"
                    value={seller?.businessPhone}
                    isEditMode={isEditMode}
                    isSuperUser={isSuperUser}
                    editData={editData}
                    onInputChange={handleInputChange}
                  />
                  <EditableDetailItem
                    icon={ReceiptIcon}
                    label="Business TIN"
                    field="businessTIN"
                    value={seller?.businessTIN}
                    isEditMode={isEditMode}
                    isSuperUser={isSuperUser}
                    editData={editData}
                    onInputChange={handleInputChange}
                  />
                  {/* Business Address with Location Autocomplete */}
                  <div style={{ ...styles.detailItem, ...styles.fullWidth }}>
                    <div style={styles.detailIcon}>
                      <LocationOnIcon style={styles.detailIconSvg} />
                    </div>
                    <div style={styles.detailContent}>
                      <div style={styles.detailLabel}>Business Address</div>
                      {isEditMode && isSuperUser ? (
                        <LocationAutocomplete
                          value={locationValue}
                          setValue={setLocationValue}
                          ready={ready}
                          data={locationData}
                          clearSuggestions={clearSuggestions}
                          mapsApiLoaded={mapsApiLoaded}
                          loadingSuggestions={placesLoading} suggestionStatus={suggestionStatus}
                          defaultValue={editData.businessAddress}
                          onLocationSelect={handleLocationSelect}
                          onClear={() => handleInputChange("businessAddress", "")}
                        />
                      ) : (
                        <div style={styles.detailValue}>{seller?.businessAddress || "N/A"}</div>
                      )}
                    </div>
                  </div>

                  {/* Account Information Section */}
                  <div style={styles.sectionTitle}>Account Information</div>
                  
                  <EditableDetailItem
                    icon={EmailIcon}
                    label="Email Address"
                    field="email"
                    value={seller?.email}
                    type="email"
                    isEditMode={isEditMode}
                    isSuperUser={isSuperUser}
                    editData={editData}
                    onInputChange={handleInputChange}
                  />
                  <DetailItem
                    icon={PersonIcon}
                    label="User Type"
                    value={formatText(seller?.userType)}
                  />
                  <DetailItem
                    icon={BadgeIcon}
                    label="User Role"
                    value={formatText(seller?.user_role)}
                  />
                  <DetailItem
                    icon={CheckCircleIcon}
                    label="Verification Status"
                    value={formatText(seller?.sellerVerification)}
                  />

                  {/* Healthcare Specific Fields */}
                  {seller?.operationMode === "HEALTHCARE" && (
                    <>
                      <div style={styles.sectionTitle}>Healthcare Information</div>
                      
                      <EditableDetailItem
                        icon={LocalHospitalIcon}
                        label="Medical License Number"
                        field="medicalLicenseNumber"
                        value={seller?.medicalLicenseNumber}
                        isEditMode={isEditMode}
                        isSuperUser={isSuperUser}
                        editData={editData}
                        onInputChange={handleInputChange}
                      />
                      <EditableDetailItem
                        icon={AssignmentIcon}
                        label="Certifications"
                        field="certifications"
                        value={seller?.certifications}
                        isEditMode={isEditMode}
                        isSuperUser={isSuperUser}
                        editData={editData}
                        onInputChange={handleInputChange}
                      />
                      <EditableDetailItem
                        icon={CategoryIcon}
                        label="Specializations"
                        field="specializations"
                        value={seller?.specializations}
                        fullWidth
                        isEditMode={isEditMode}
                        isSuperUser={isSuperUser}
                        editData={editData}
                        onInputChange={handleInputChange}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Edit Actions Bar */}
            {isEditMode && isSuperUser && (
              <div style={styles.editActionsBar}>
                <button
                  style={styles.cancelButton}
                  onClick={handleEditToggle}
                  disabled={isSaving}
                >
                  <CancelIcon style={{ fontSize: "18px" }} />
                  Cancel
                </button>
                <button
                  style={styles.saveButton}
                  onClick={handleSaveChanges}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <CircularProgress size={18} style={{ color: "#ffffff" }} />
                  ) : (
                    <>
                      <SaveIcon style={{ fontSize: "18px" }} />
                      Save Changes
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </Container>
      )}

      {/* Image Modal */}
      <Modal show={showModal} onHide={handleCloseModal} onMouseLeave={handleCloseModal} centered size="lg">
        <Modal.Header closeButton style={{ borderBottom: "none", padding: "16px 20px" }}>
          <Modal.Title>
            Business Trading License
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "0 20px 20px" }}>
          <img
            src={seller?.businessTradingLicense}
            alt="Business Trading License"
            style={{ width: "100%", borderRadius: "8px" }}
          />
        </Modal.Body>
      </Modal>

      {/*
        Seeded-vendor activation modal.

        Shown only when admin clicks "Verify & Activate" on a vendor whose
        email is still the `seed-<phone>@lusuku.pending` placeholder. Lets
        the admin capture a real email (optional — vendor may be phone-only)
        and confirm/fix the phone number. On submit we pass both to the
        existing `verifySeller` action which:
          1) upgrades the placeholder email to the real one (if provided),
          2) writes the phone into Users.phoneNumber (if not already set),
          3) auto-creates a PasswordReset doc and emails the magic link
             when a real email is captured.
        Phone-only vendors skip the email — they log in via the existing
        SMS OTP flow on the mobile app.
      */}
      <Modal
        show={showActivationModal}
        onHide={handleCloseActivationModal}
        centered
      >
        <Modal.Header closeButton style={{ borderBottom: "none", padding: "16px 20px" }}>
          <Modal.Title>
            Verify & Activate Vendor
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "0 20px 20px" }}>
          <p style={{ fontSize: "13px", color: "#555", marginBottom: "16px" }}>
            This vendor was seeded and needs real contact details to log in.
            Provide an email and/or confirm the phone number. If an email is
            provided the vendor will receive a password-reset link; phone-only
            vendors can log in on the mobile app using SMS OTP.
          </p>
          <div style={{ marginBottom: "14px" }}>
            <label
              htmlFor="activation-email"
              style={{
                display: "block",
                fontSize: "12px",
                fontWeight: "600",
                color: "#333",
                marginBottom: "6px",
              }}
            >
              Email address (optional)
            </label>
            <input
              id="activation-email"
              type="email"
              style={styles.editInput}
              value={activationEmail}
              onChange={(e) => setActivationEmail(e.target.value)}
              placeholder="vendor@example.com"
            />
          </div>
          <div style={{ marginBottom: "4px" }}>
            <label
              htmlFor="activation-phone"
              style={{
                display: "block",
                fontSize: "12px",
                fontWeight: "600",
                color: "#333",
                marginBottom: "6px",
              }}
            >
              Phone number
            </label>
            <input
              id="activation-phone"
              type="tel"
              style={styles.editInput}
              value={activationPhone}
              onChange={(e) => setActivationPhone(e.target.value)}
              placeholder="256700000000"
            />
            <div style={{ fontSize: "11px", color: "#888", marginTop: "4px" }}>
              Pre-filled from the business phone captured at seeding. Digits
              only — country code included, no spaces or dashes.
            </div>
          </div>
        </Modal.Body>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "12px 20px 20px",
          }}
        >
          <button
            style={styles.cancelButton}
            onClick={handleCloseActivationModal}
          >
            <CancelIcon style={{ fontSize: "18px" }} />
            Cancel
          </button>
          <button
            style={styles.saveButton}
            onClick={handleSubmitActivation}
          >
            <VerifiedUserIcon style={{ fontSize: "18px" }} />
            Verify & Send Activation
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default SellerDetailsCard;
